import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { EnvironmentsInterface } from '../types';

@Injectable()
export class TitleService {
  private titleService = inject(Title);

  setTitle(newTitle: string, environment: EnvironmentsInterface) {
    const env = environment.production ? '' : ` [${environment.name}]`;
    this.titleService.setTitle(`${newTitle}${env}`);
  }
}
